import * as environment from '../config/environment';
import { BaseAPI } from './BaseAPI';

class KullaniciYonetimiAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "Kullanici";
        super(baseUrl);
    }

   

    kullaniciSearch(otpRequest: KullaniciSearchRequest) {
        return this.post("KullaniciSearch", otpRequest);
    }

    kullaniciGet(otpRequest: KullaniciGetRequest) {
        return this.post("KullaniciGet", otpRequest);
    }
    kullaniciAdresGet(otpRequest: KullaniciAdresGetRequest) {
      return this.post("AdresGet", otpRequest);
  }

}
export default new KullaniciYonetimiAPI();
class KullaniciGetRequest {
  kullaniciId?: number;            
 
  

  constructor(init?: Partial<KullaniciGetRequest>) {
    Object.assign(this, init);
  }
}
class KullaniciAdresGetRequest {
  kullaniciId?: number;            
 
  

  constructor(init?: Partial<KullaniciAdresGetRequest>) {
    Object.assign(this, init);
  }
}
class KullaniciSearchRequest {
  tcNo?: string;            
  adi?: string;    
  soyadi?: string;    
  

  constructor(init?: Partial<KullaniciSearchRequest>) {
    Object.assign(this, init);
  }
}
export { KullaniciSearchRequest, KullaniciGetRequest ,KullaniciAdresGetRequest};